import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import InfoItem, { InfoItemProps } from './InfoItem';

export interface InfoItemsListProps {
    fields: InfoItemProps[];
    lightFont?: boolean;
    title?: string;
}

const InfoItemsList: FC<InfoItemsListProps> = ({ fields, lightFont, title }) => {
    return (
        <Box>
            {title && (
                <Typography
                    sx={{ color: 'text.primary', fontSize: 'inherit', fontWeight: 'medium' }}
                    variant="h2"
                    gutterBottom
                >
                    {title.toUpperCase()}
                </Typography>
            )}
            {fields.map((field) => (
                <InfoItem key={`detail-line-${field.label}`} lightFont={lightFont} {...field} />
            ))}
        </Box>
    );
};

export default InfoItemsList;
